import { Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import ConditionalWrapper from 'components/ConditionalWrapper'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    debtorTitleStyled: {
      marginBottom: `${theme.spacing(1)} !important`
    }
  })
)

const DebtorTitle = ({ dependson }: { dependson?: string }) => {
  const { debtorTitleStyled } = useStyles()

  return (
    <ConditionalWrapper dependson={dependson}>
      <Typography variant="h4" className={debtorTitleStyled}>
        Anzahl Kreditnehmer
      </Typography>
    </ConditionalWrapper>
  )
}

export default DebtorTitle
